import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import withReducer from 'app/store/withReducer';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeviceService from '../service/DeviceService';
import reducer from './store';
import { setDeviceList, setSelectedDevice } from './store/DeviceSelectionSlice';

function DeviceSelection(props) {
	const dispatch = useDispatch();
	const user = useSelector(({ auth }) => auth.user);
	const deviceList = useSelector(rootState => rootState.device.selection.deviceList);
	const selectedDevice = useSelector(rootState => rootState.device.selection.selectedDevice);

	useEffect(() => {
		// if (user.role.length > 0) DeviceService.findAllSelection().then(resp => dispatch(setDeviceList(resp)));
	}, []);

	const handleAutoCompleteOnChange = (e, v, r) => {
		if (r === 'select-option') {
			dispatch(setSelectedDevice(v));
		} else if (r === 'clear') {
			dispatch(setSelectedDevice(e.target.value));
		}
	};
	return (
		<Autocomplete
			options={deviceList}
			getOptionLabel={option => `${option.infrastructureElement.name} - ${option.location.name} - ${option.name}`}
			onChange={(e, v, r) => handleAutoCompleteOnChange(e, v, r)}
			value={selectedDevice}
			style={{ width: 300 }}
			renderInput={params => <TextField {...params} label="Device" variant="outlined" />}
		/>
	);
}
export default withReducer('device', reducer)(DeviceSelection);
